import apiPaths from '../api-paths';

export default {
  // Konta bankowe zgłoszone przez podatnika do wykazu, wraz z rozpoznaną nazwą banku i SWIFT-em.
  bankAccounts(nip) {
    return axios.post(`${ apiPaths.API }/vat-whitelist/bank-accounts`, { nip });
  },
};
